<template>
  <div class="ac-card-content">
    <div class="ac-header-container justify-start">
      <button 
        type="button" 
        class="ac-close-button" 
        @click="() => toggleActionModal(false)"
      >
        <img
          src="@shared/assets/img/general/x-black.png"
          alt="x"
          class="ac-close"
        />
      </button>
      <div class="ac-header">Resend Invitation</div>
    </div>
    <div class="ac-body-container">
      <div class="mb-2">
        Looks like last time this member was invited was 
        <b>{{ dateAndYear(selectedProspect.updateDate) }}</b>
      </div>
      <div class="mb-2">
        This will send a text message invitation to the member again
      </div>
      <div>
        Are you sure you want to resend the invitation to 
        {{ selectedProspect.firstName }} {{ selectedProspect.lastName }}?
      </div>
    </div>
    <div class="ac-footer-container">
      <button
        type="button"
        class="ac-form-button"
        @click="() => toggleActionModal(false)"
      >
        Cancel
      </button>
      <button
        type="button"
        class="ac-form-button"
        @click="resendInvite"
        :disabled="processing"
      >
        Resend
      </button>
    </div>
    <ProcessOverlay 
      :show="processing"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex';

import apiClient from '@shared/lib/general/apiClient';
import unitPreferencesMixin from '@shared/mixins/unitPreferencesMixin';
import ProcessOverlay from '@shared/components/ProcessOverlay.vue';

export default {
  name: 'TextWarning',
  components: {
    ProcessOverlay,
  },
  mixins: [unitPreferencesMixin],
  data() {
    return {
      processing: false,
    };
  },
  props: {
    toggleActionModal: Function,
  },
  computed: {
    ...mapState({
      selectedProspect: (state) => state.customer.selectedProspect,
    }),
  },
  methods: {
    async resendInvite() {
      this.processing = true;
      try {
        await apiClient({
          method: 'POST',
          url: '/customers/resend/invite',
          data: this.selectedProspect,
        });
        this.$store.dispatch('showSuccessToast', {
          message: `You resent invitation to ${this.selectedProspect.firstName} ${this.selectedProspect.lastName}.`,
        });
        this.$store.dispatch('getAllCustomers');
        this.toggleActionModal(false);
      } catch (err) {
        console.error(err);
      } finally {
        this.processing = false;
      }
    },
  }
};
</script>
